<template>
  <SectionSplit
    class="Meeting2026 reverse"
    src="../../assets/landing-finances/meeting-2026.jpg">
    <h3>
      {{ $t("title") }}
    </h3>
    <p
      v-for="(paragraph, index) in $t('paragraphs')"
      :key="index"
      v-html="paragraph" />
  </SectionSplit>
</template>

<script>
import SectionSplit from 'views/components/SectionSplit'

export default {
  components: { SectionSplit },
}
</script>

<style lang="scss">
.Meeting2026 {
  .Splitter-body {
    max-width: 50rem;
  }

  .body {
    padding: 2rem 0;
  }
}
</style>

<i18n>
{
  "en": {
    "title": "Due to the convened meeting of bondholders of Sun Investment Group, UAB",
    "paragraphs": [
      "Dear investors,<br><br>We provide the Convocation of bondholders&#39; meeting of Sun Investment Group, UAB on 20th May, 2026.<br><br>More detailed information is attached in additional documents.<br>Nasdaq link: <a href=\"https://view.news.eu.nasdaq.com/view?id=1436879&lang=en\" target=\"_blank\">Due to the convened meeting of bondholders of Sun Investment Group, UAB</a>"
    ]
  },
  "lt": {
    "title": "Dėl šaukiamo Sun Investment Group, UAB obligacijų savininkų susirinkimo",
    "paragraphs": [
      "Gerbiami investuotojai,<br><br>Teikiame pranešimą apie 2026 m. gegužės 20 d. šaukiamą Sun Investment Group, UAB obligacijų savininkų susirinkimą.<br><br>Išsamesnė informacija pateikiama pridedamuose dokumentuose.<br>Nasdaq nuoroda: <a href=\"https://view.news.eu.nasdaq.com/view?id=1436879&lang=lt\" target=\"_blank\">Dėl šaukiamo Sun Investment Group, UAB obligacijų savininkų susirinkimo</a>"
    ]
  }
}
</i18n>
